// Regional Performance

<template>
  <section class="lms3040-container">
    <div class="lms3040 white border-main shadow-dark">
      <Ul class="crumbs text-charcoal mb-2">
        <li><sym-link to="/">Home</sym-link></li>
        <li><span aria-current="page">Regional Performance</span></li>
      </Ul>
      <sym-card class="lams" headerClass="p-1 pl-2">
        <div slot="header" class="reg-stat justify-between align-items-center">
          <p class="reg-stat-title serif bold">Regional Statistics</p>
          <div class="control-container text-charcoal">
            <sym-combo
              v-model="regionId"
              :input-width="50"
              display-field="regionFullName"
              :datasource="regions"
              @changed="onRegionIdChanged"
            ></sym-combo>
            <sym-combo
              v-model="yearId"
              caption="Year"
              :caption-width="14"
              :input-width="48"
              display-field="yearId"
              :datasource="detailYears"
              @changed="onYearIdChanged"
              class="year-control"
            ></sym-combo>
          </div>
        </div>
      </sym-card>

      <sym-tabs
        id="tabs"
        v-model="activeTabIndex"
        @changed="onActiveTabIndexChanged"
      >
        <sym-tab title=" IVAS" icon="cube">
          <div class="table-scroll-wrapper">
            <sym-card class="lams-light mb-2 border-main" bodyClass="p-2">
              <p class="reg-summary-title serif bold text-charcoal">
                Summary ● All Regions
              </p>
            </sym-card>

            <div class="chart-container mb-3">
              <div class="w-100 pos-relative border-main">
                <canvas id="all-regions-chart" class="p-2"></canvas>
              </div>

              <span class="national-header text-center "
                >{{ yearId }} NATIONAL PERFORMANCE EFFICIENCY</span
              >

              <table class="sm-2 scroll-table-national-perfomance">
                <thead>
                  <tr class="whitesmoke text-center">
                    <th class="w-30">Region</th>
                    <!-- <th class="w-30">Transaction</th> -->
                    <th class="w-30">Target</th>
                    <th class="w-30">Submitted</th>
                    <th class="w-30">Approved</th>
                    <th class="w-30">Rejected</th>
                    <th class="w-30">In-Process</th>
                    <th class="w-30">Residual</th>
                    <th class="w-30">Target</th>
                    <th class="w-30">Actual</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(app, index) in allregion" :key="index">
                    <td class="w-40">{{ app.boardCode }}</td>
                    <td class="w-40">
                      {{ Number(app.targetCount).toLocaleString() }}
                    </td>
                    <td class="w-40">
                      {{ Number(app.submittedCount).toLocaleString() }}
                    </td>
                    <td class="w-40">
                      {{ Number(app.approvedCount).toLocaleString() }}
                    </td>
                    <td class="w-40">
                      {{ Number(app.rejectedCount).toLocaleString() }}
                    </td>
                    <td class="w-40">
                      {{ Number(app.inProcessCurrentCount).toLocaleString() }}
                    </td>
                    <td class="w-40">
                      {{ Number(app.residualCount).toLocaleString() }}
                    </td>
                    <td class="w-40">
                      {{ Number(app.targetPercentage).toLocaleString() + "%" }}
                    </td>
                    <td class="w-40">
                      {{ Number(app.actualPercentage).toLocaleString() + "%" }}
                    </td>
                    <!-- <td class="w-40">
                      {{ Number(app.totalCount).toLocaleString() }}
                    </td>
                    <td class="w-30">Total</td> -->
                  </tr>

                  <tr
                    v-for="(summary, indexA) in allRegionSummary"
                    :key="indexA"
                  >
                    <td class="bold text-left">Total</td>
                    <td class="w-40">
                      {{ Number(summary.targetCount).toLocaleString() }}
                    </td>
                    <td class="w-40">
                      {{ Number(summary.submittedCount).toLocaleString() }}
                    </td>
                    <td class="w-40">
                      {{ Number(summary.approvedCount).toLocaleString() }}
                    </td>
                    <td class="w-40">
                      {{ Number(summary.rejectedCount).toLocaleString() }}
                    </td>
                    <td class="w-40">
                      {{
                        Number(summary.inProcessCurrentCount).toLocaleString()
                      }}
                    </td>
                    <td class="w-40">
                      {{ Number(summary.residualCount).toLocaleString() }}
                    </td>
                    <td class="w-40">
                      {{ summary.targetPercentage + "%" }}
                    </td>
                    <td class="w-40">
                      {{
                        Number(summary.actualPercentage).toLocaleString() + "%"
                      }}
                    </td>
                    <!-- <td class="w-40">{{ summary.totalCount }}</td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </sym-tab>
        <!-- <sym-tab title=" PLA" icon="copy">
          <div class="table-scroll-wrapper">
            <sym-card class="lams-light mb-2 border-main" bodyClass="p-2">
              <p class="reg-summary-title serif bold text-charcoal">
                Summary ● All PLA
              </p>
            </sym-card>

            <div class="chart-container mb-3">
              <div class="w-100 pos-relative border-main">
                <canvas id="all-regions-pla-chart" class="p-2"></canvas>
              </div>

              <div class="w-100 pos-relative border-main"> WAG GAGAMITIN
                <canvas id="visits-chart" class="p-2"></canvas>
              </div>

              <span class="national-header text-center ">
                {{ yearId }} NATIONAL PERFORMANCE EFFICIENCY</span
              >

              <table class=" scroll-table-national-perfomance ">
                <thead>
                  <tr class="whitesmoke text-center">
                    <th class="">Region</th>
                    <th class="w-30">Transaction</th>
                    <th class="w-30">Target</th>
                    <th class="">Submitted</th>
                    <th class="">Approved</th>
                    <th class="w-30">Rejected</th>
                    <th class="w-30">In-Process</th>
                    <th class="w-30">Residual</th>

                    <th class="w-30">Target</th>
                    <th class="w-30">Actual</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(app, index) in allregion" :key="index">
                    <td class="w-10">{{ app.boardCode }}</td>
                    <td class="w-40">{{ app.targetCount }}</td>
                    <td class="w-10">
                      {{ Number(app.submittedCount).toLocaleString() }}
                    </td>
                    <td class="w-10">
                      {{ Number(app.approvedCount).toLocaleString() }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="w-100 pos-relative border-main"> WAG GAGAMITN
                <canvas id="national-performance" class="p-2"></canvas>
              </div>
              <div class="w-100 pos-relative border-main"> WAG GAGAMITIN
                <canvas id="visits-chart" class="p-2"></canvas>
              </div>
            </div>
          </div>
        </sym-tab> -->
      </sym-tabs>

      <button
        type="button"
        class="primary text-center w-100 lg-1 shadow mt-2 mb-2"
        @click="goBack()"
      >
        <i class="fa fa-arrow-left mr-2"></i> Back
      </button>
    </div>
  </section>
</template>

<script>
import { get } from "../../js/http";

import * as lams from "../../js/lams";

import { drawBarChart } from "../../js/graph"; //drawLineChart

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms3040",

  data() {
    return {
      regionId: 0,
      regions: [],
      regionsPla: [],
      charts: [],
      chartsPla: [],
      allregion: [],
      summaryDateRange: "",
      yearId: this.core.getCurrentYear(),
      detailYears: [],
      offices: [],
      submittedCounts: [],
      approvedCounts: [],
      pendingCounts: [],
      rejectedCounts: [],
      cancelledCounts: [],
      residualCounts: [],
      inProcessCounts: [],
      activeTabIndex: 0,
      visitDates: [],
      visitCounts: [],
      allRegionSummary: [],
      submittedPlaCounts: [],
      approvedPlaCounts: [],

      // ivas: {
      //   Total: {
      //     submittedTotals: 0,
      //     rejectedTotals: 0,
      //     approvedTotals: 0,
      //     pendingTotals: 0,

      //     inProcessTotals: 0,
      //   },
      // },
    };
  },

  // computed: {
  //   isCurrentYear() {
  //     //  return true;
  //     console.log(this.yearId);

  //     console.log(me.core.getCurrentYear());
  //     return this.yearId === me.core.getCurrentYear();
  //   },
  // },

  methods: {
    loadData() {
      const me = this,
        wait = me.wait();

      me.getStats().then(
        (data) => {
          me.stopWait(wait);

          if (this.core.getCurrentYear() === me.yearId) {
            me.summaryDateRange = lams.getCurrentYearCoverage();
          } else {
            me.summaryDateRange = "Year " + me.yearId;
          }

          // me.loadData();
          // me.detailYears = lams.getYearsDatasource();

          // regional summary
          // me.allregion = data.stats.map;
          // me.summaryYears = data.map((o) => o.yearId);
          me.offices = data.stats.map((o) => o.boardCode);
          me.submittedCounts = data.stats.map((o) => o.submittedCount);
          me.approvedCounts = data.stats.map((o) => o.approvedCount);
          me.rejectedCounts = data.stats.map((o) => o.rejectedCount);
          me.pendingCounts = data.stats.map((o) => o.pendingCount);
          me.cancelledCounts = data.stats.map((o) => o.cancelledCount);
          me.residualCounts = data.stats.map((o) => o.residualCount);
          me.inProcessCounts = data.stats.map((o) => o.inProcessCurrentCount);
          // me.inProcessCounts = data.stats.map((o) => o.inProcessCount);

          // me.targetCounts = data.stats.map.()

          // // site visits
          // me.visitDates = data.visits.map((o) => {
          //   return me.core.toDateFormat(o.visitDate, true, "dd MMM");
          // });
          // me.visitCounts = data.visits.map((o) => o.visitCount);
          // eslint-disable-next-line
          // me.drawCharts();

          me.allregion = data.stats;
          // console.log(me.offices);
          //JYL
          me.getRegionalStatsPla().then((data) => {
            if (data) {
              me.offices = data.map((o) => o.boardCode);
              me.submittedPlaCounts = data.map((o) => o.submittedCount);
              me.approvedPlaCounts = data.map((o) => o.approvedCount);
              me.regionsPla = data;
            }
          });
          //JENON
          me.getRegionalSummaryStats().then((summary) => {
            if (summary) {
              me.allRegionSummary = summary;
            }
          });

          //JYL
          me.drawCharts();
        },

        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },
    getTargetPath() {
      return {
        name: this.$options.name,
        query: {
          activeTab: this.activeTabIndex,
        },
      };
    },
    syncValues(p, q) {
      const me = this;

      if ("activeTab" in q) {
        let index = parseInt(q.activeTab);
        if (!isNaN(index)) {
          me.activeTabIndex = index;
        }
      }
    },

    // API calls

    getStats() {
      const me = this,
        wait = me.wait();

      let data = {};

      return me
        .getRegionaalStats()
        .then((stats) => {
          data.stats = stats;
          return me.getVisitStats();
        })
        .then((visits) => {
          me.stopWait(wait);
          data.visits = visits;
          return data;
        })
        .catch((fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        });
    },

    getRegionaalStats() {
      return get("api/stats/regions/year/" + this.yearId);
    },

    getRegionalSummaryStats() {
      return get("api/stats/regions/summary-year/" + this.yearId);
    },

    getRegionalStatsPla() {
      return get("api/stats/regions-pla/year/" + this.yearId);
    },

    getVisitStats() {
      return get("api/stats/visit");
    },

    // event handlers

    onRegionIdChanged(regionId) {
      let route = {
        name: "lms3010",
        query: {
          regionId: regionId,
        },
      };
      this.go(route);
    },
    onActiveTabIndexChanged() {
      this.reload();
    },
    //JENON LEE
    onYearIdChanged() {
      // console.log(this.core.getCurrentYear());
      this.loadData(); //this.reload();
      // console.log(this.loadData());
    },

    // helpers

    drawSummaryChart() {
      const me = this;

      const mq = window.matchMedia("(max-width: 600px)");
      let aspectRatio = 2.5;
      if (mq.matches) {
        aspectRatio = 1;
      }
      let chartData = {
        labels: me.offices,

        datasets: [
          {
            label: "Submitted",
            data: me.submittedCounts,
            backgroundColor: "#fbbe0b", //"#3cba9f",
          },

          {
            label: "Approved",
            data: me.approvedCounts,
            backgroundColor: "#507cc4",
          },

          {
            label: "Rejected",
            data: me.rejectedCounts,
            backgroundColor: "#c45850",
          },
          {
            label: "In-Process",
            data: me.inProcessCounts,
            backgroundColor: "#5A9367",
          },
        ],
      };

      // let chartData = {
      //   labels: me.offices,

      // datasets: [
      //   {
      //     label: "Submitted",
      //     data: me.submittedCounts,
      //     backgroundColor: "#fbbe0b", //"#3cba9f",
      //   },

      //   {
      //     label: "Approved",
      //     data: me.approvedCounts,
      //     backgroundColor: "#507cc4",
      //   },

      // {
      //   label: "Pending",
      //   data: me.pendingCounts,
      //   backgroundColor: "#c49d50",
      // },

      // {
      //   label: "Rejected",
      //   data: me.rejectedCounts,
      //   backgroundColor: "#c45850",
      // },

      // {
      //   label: "In-Process",
      //   data: me.inProcessCounts,
      //   backgroundColor: "#5A9367",
      // },
      // {
      //   label: "Residual",
      //   data: me.residualCounts,
      //   backgroundColor: "violet", //"#c45850",
      // },
      // {
      //   label: "Cancelled",
      //   data: me.cancelledCounts,
      //   backgroundColor: "#c45850",
      // },
      // ],
      // };

      // let chartPlaData = {
      //   labels: me.offices,

      //   datasets: [
      //     {
      //       label: "Submitted",
      //       data: me.submittedPlaCounts,
      //       backgroundColor: "#fbbe0b", //"#3cba9f",
      //     },

      //     {
      //       label: "Approved",
      //       data: me.approvedPlaCounts,
      //       backgroundColor: "#507cc4",
      //     },
      //   ],
      // };

      let options = {
        scales: {
          x: {
            ticks: {
              font: {
                size: 14,
                weight: 700,
              },
            },
          },
          y: {
            beginAtZero: true,
          },
        },

        plugins: {
          title: {
            display: true,
            text: "Regional Statistics",
            font: {
              size: 20,
              lineHeight: 1,
            },
          },

          subtitle: {
            display: true,
            text: me.summaryDateRange,
            font: {
              size: 16,
            },
            padding: {
              bottom: 0,
            },
          },

          legend: {
            labels: {
              boxWidth: 20,
            },
          },
        },

        // aspectRatio: 1.4
        aspectRatio: aspectRatio,
      };

      let chart = drawBarChart("all-regions-chart", chartData, options);
      this.charts.push(chart);

      // let chartPla = drawBarChart(
      //   "all-regions-pla-chart",
      //   chartPlaData,
      //   options
      // );
      // this.charts.push(chartPla);
    },

    drawCharts() {
      const me = this;

      me.charts.forEach((chart) => {
        chart.destroy();
        chart = null;
      });

      // me.chartsPla.forEach((chartPla) => {
      //   chartPla.destroy();
      //   chartPla = null;
      // });

      // me.drawVisitChart();

      setTimeout(() => {
        me.drawSummaryChart();
        // me.drawSummaryChart1();
      }, 600);
    },
  },

  mounted() {
    const me = this;

    me.dom.on(window, "resize", me.drawCharts);

    me.regions = lams.getRegionList().slice(0);
    me.regions.unshift({
      regionId: 0,
      regionFullName: "--- Select Region ---",
    });
    // ("jenon");
    // console.log(this.core.getCurrentYear());
    me.summaryDateRange = lams.getCurrentYearCoverage();
    me.loadData();
    me.detailYears = lams.getYearsDatasource();
  },

  beforeDestroy() {
    this.dom.off(window, "resize", this.drawCharts);
  },
};
</script>

<style scoped>
.national-header {
  font-weight: bold;
}
.lms3040-container {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}
.year-control {
  margin-left: 0.5rem;
}

.lms3040 {
  width: 80%;
  padding: 1rem 2rem;
  border-radius: 0.375rem;
}

.reg-stat-title,
.reg-summary-title {
  font-size: 1.125rem;
  margin-bottom: 0;
  padding-left: 0.125rem;
}

.reg-stat {
  display: flex;
}

.reg-stat >>> .form-control {
  margin-bottom: 0;
}
.control-container {
  display: flex;
}
.chart-container {
  display: grid;
  /* grid-template-columns: 1fr 1fr; */
  gap: 0.5rem;
  /* grid-auto-flow: dense; */
}
/* .scroll-table-national-perfomance-1 {
    width: 50%;
} */

@media (max-width: 1024px) {
  .lms3040 {
    width: 90%;
    padding: 2rem;
  }
  .scroll-table-national-perfomance {
    overflow-x: auto;
    white-space: nowrap;
  }
  .national-header {
    text-align: center;
    /* font-weight: bold; */
  }
}

@media (max-width: 800px) {
  .chart-container {
    display: block;
  }
  .scroll-table-national-perfomance {
    display: block;
  }
  .national-header {
    text-align: center;
    /* font-weight: bold; */
  }
  .control-container {
    margin-bottom: 0.25rem;
  }
}

@media (max-width: 640px) {
  .lms3040-container {
    padding-top: 0;
    padding-bottom: 0;
  }
  .scroll-table-national-perfomance {
    display: block;
  }

  .lms3040 {
    width: 100%;
    padding: 1rem;
    border-radius: 0;
  }

  .reg-stat {
    display: block;
  }

  .reg-stat-title,
  .reg-summary-title {
    font-size: 1rem;
  }

  .reg-stat-title {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .national-header {
    text-align: center;
    /* font-weight: bold; */
  }

  .control-container {
    display: block;
    margin-bottom: 0;
  }
  .year-control {
    margin-left: 0;
  }
}

@media (max-width: 420px) {
  .lms3000 {
    padding: 0.5rem;
  }
  .national-header {
    text-align: center;
    /* font-weight: bold; */
  }
}
</style>
